// src/pages/Templates/index.jsx
import React from "react";
import TemplateCard from "../../components/TemplateCard";
import  {templatesData}  from "../../data/dummyData/templates";

const Templates = () => {
  return (
    <div
    style={{
      display: "flex",
      backgroundColor: "#F5F7FA", 
      height: "100vh", 
      flexDirection: "column",
      padding: "20px",
    }}>
       <div className="flex justify-between items-center mb-6">
        <h1 className="text-2xl font-bold">Templates</h1>
        <button className="bg-primary text-white px-4 py-2 rounded-lg hover:bg-primary-dark transition">
          New Template +
        </button>
      </div>
      <div className="grid grid-cols-4 gap-4">
        {templatesData.map((template) => (
          <TemplateCard key={template.id} template={template} />
        ))}
      </div>
    </div>
  );
};

export default Templates;
